module.exports = __webpack_public_path__ + "img/Banking.172b3050.png";